import React, { useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux';
import { UserModel } from '../../../modules/auth/models/UserModel'
import PhoneInput from '../../ShippingLocationsPage/PhoneInput'
import { RootState } from '../../../../setup/redux/RootReducer';
import { CountryOptions } from '../../../data/CountryOptions';
import ZipcodesWithCountry from '../../LTLandVolumeTLPages/ZipcodesWithCountry';
import { FormsEditProps } from '../../../pages/vendors/models';
import { InputStyled } from '../../Inputs.styled';

const BillToInformation = ({formik}: FormsEditProps) => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [zipcode, setZipcode] = useState('')
    const [city, setCity] = useState({
        City: formik.values.billToInformation?.city,
        Country: CountryOptions.filter(country => country.CodePrimus === formik.values.billToInformation?.country)[0]?.Code,
        Name: "",
        State: formik.values.billToInformation?.state,
        Zipcode: formik.values.billToInformation?.zipcode,
        isSL: false,
        isZipcode: true,
        id: null
    })
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    return (
        <>
            <div className="row align-items-center">
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Name</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('billToInformation.name')}
                        fontSize={fontSize}
                    />
                </div>
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Account#</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('billToInformation.account')}
                        fontSize={fontSize}
                    />
                </div>
            </div>

            <div className="row align-items-center mt-5">
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Address</label>
                </div>
                <div className="col-7 col-sm-6 col-md-3 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='new-password'
                        {...formik.getFieldProps('billToInformation.address')}
                        fontSize={fontSize}
                    />
                </div>
                <div className="col-5 col-sm-4 col-md-2 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='new-password'
                        {...formik.getFieldProps('billToInformation.address1')}
                        fontSize={fontSize}
                    />
                </div>
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>C&#8204;ity</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5">
                    <ZipcodesWithCountry
                        zipcodeLocal={zipcode}
                        setZipcodeLocal={setZipcode}
                        setDataFormik={formik?.setFieldValue}
                        setFieldError={formik?.setFieldError}
                        data={city}
                        setData={setCity}
                        countryOptions={CountryOptions}
                        userData={user}
                        error={''}
                        touched={{}}
                        setFieldTouched={() => {}}
                        editVendor
                        valueName='billToInformation'
                    />
                </div>
            </div>

            <div className="row align-items-center mt-5">
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Phone</label>
                </div>
                <div className="col-12 col-sm-10 col-md-4 col-lg-3">
                    <PhoneInput
                        value={formik.values.billToInformation.phone}
                        setDataFormik={formik.setFieldValue}
                        name='billToInformation.phone'
                        countryCode={formik.values.billToInformation.country}
                        deleteSelectCountry={false}
                    />
                </div>
                <div className="d-none d-lg-flex col-lg-2"></div>
            </div>
        </>
    )
}

export default BillToInformation